"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.compactStyles = exports.baseStyles = void 0;
// NOTE: considering adding a specifc prop for grid row padding
var baseStyles = exports.baseStyles = {
  gap: {
    base: 4,
    tablet: 8
  },
  templateColumns: 'repeat(12, 1fr)'
};
var compactStyles = exports.compactStyles = {
  gap: 4
};